import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SwapIcon from 'assets/swap.svg';

const getFlagUrl = (currencyCode) =>
  `https://flagcdn.com/w40/${currencyCode?.slice(0, 2).toLowerCase()}.png`;

export const SwapFlags = ({ swaps }) => {
  const [sender, receiver] = swaps;
  const [swapped, setSwapped] = useState(false);

  return (
    <motion.div
      className="relative flex items-center"
      onMouseEnter={() => setSwapped(true)}
      onMouseLeave={() => setSwapped(false)}
    >
      <div className="flex -space-x-2">
        {[swapped ? receiver : sender, swapped ? sender : receiver].map(
          (flag, i) => (
            <img
              key={i}
              src={getFlagUrl(flag.currency)}
              className="w-8 h-8 rounded-full ring-2 ring-white"
              alt=""
            />
          )
        )}
      </div>
      <div className="absolute -bottom-1 left-10 bg-[#0E3061] p-1.5 rounded-full border-2 border-white w-6 h-6 flex items-center justify-center shadow-md">
        <img src={SwapIcon} alt="Swap" className="w-3.5 h-3.5" />
      </div>
    </motion.div>
  );
};
